module.exports = __webpack_public_path__ + "img/32.92ab5c3a.jpg";